import React, {useContext} from 'react'
import styled from 'styled-components/macro'

styled

export const DoActionContext = React.createContext()
export const useDoAction = () => useContext(DoActionContext)